module.exports = __webpack_public_path__ + "static/media/400138_02.a770c23c.png";